import styled from "styled-components";

import React, { useEffect, useState } from "react";
import { Accordion } from "semantic-ui-react";
import { connect } from "react-redux";
import { FileList } from "./filelist";
import { AccordionHead } from "./accordion-head";
import { UploadForm } from "./upload-form";
import { RoleRequired } from "../auth/role-required";
import { permissions } from "../../constant/permissions";
import { t } from "../../constant/translations";

type Props = {};

const StyledItalicDiv = styled.div`
  font-style: italic;
`;

const FileBoxContainer = (props: Props) => {
  const [state, setState] = useState({ active: {} });

  useEffect(() => {
    if (props.lastUpload) {
      openDirectory(props.lastUpload.directory_name);
    }
  }, [props.lastUpload]);

  const mapSections = (files, dirs) => {
    const dirRemap = {};
    dirs.map((entry) => {
      dirRemap[entry.id] = entry.name;
    });

    const sections = {};
    files.map((entry) => {
      const dir =
        dirRemap[entry.directory_id] ||
        entry.directory_name ||
        t("file.common");
      if (!sections[dir]) {
        sections[dir] = {
          id: entry.directory_id,
          name: dir,
          entries: [],
        };
      }
      sections[dir].entries.push(entry);
    });

    return sections;
  };

  const openDirectory = (selected) => {
    const active = state.active;
    active[selected] = !active[selected];
    setState({ active });
  };

  const renderPanels = (sections) => {
    const results = [];
    Object.keys(sections).forEach((key) => {
      results.push(
        <AccordionHead
          key={key}
          section={sections[key]}
          active={state.active[key] === true}
          activate={openDirectory}
        />
      );
      results.push(
        <Accordion.Content
          key={`${key}-filelist`}
          active={state.active[key] === true}
        >
          <FileList files={sections[key].entries} />
        </Accordion.Content>
      );
    });

    if (results.length === 0) {
      return (
        <StyledItalicDiv>{t("file.no_attached_documents")}</StyledItalicDiv>
      );
    }

    return (
      <Accordion styled fluid>
        {results}
      </Accordion>
    );
  };

  const sections = mapSections(props.files, props.dirs);

  return (
    <>
      <RoleRequired staff={true} permission={permissions.boardEdit}>
        <UploadForm />
      </RoleRequired>
      {renderPanels(sections)}
    </>
  );
};

function mapStateToProps(state) {
  return {
    files: state.file.entities || [],
    dirs: state.fileDir.entities || [],
    lastUpload: state.file.lastUpload,
  };
}

export const FileBox = connect(mapStateToProps, undefined)(FileBoxContainer);
